import React  from "react";
import {
	DataGridPro,
	GridColumns,
	GridRenderCellParams,
	GridToolbar,
	useGridApiRef,
} from "@mui/x-data-grid-pro";
import { Box, Chip } from "@material-ui/core";
import { criteriasDataGridProps } from "./CriteriasDataGrid";

const CriteriasDataGrid: React.FC<criteriasDataGridProps> = (props) => {
	const { criterias,
		onRowsSelected,
		rowSelection
	} = props;

	const apiRef = useGridApiRef();

	const setRowSelection = (e) => {
		onRowsSelected(e[0]);
	}

	const columns: GridColumns = [
		{ field: "name", headerName: "Name", width: 150, disableColumnMenu: true, resizable: false },
		{ field: "trigger", headerName: "Trigger", width: 100, disableColumnMenu: true, resizable: false },
		{ field: "action", headerName: "Action", width: 100, disableColumnMenu: true, resizable: false },
		{
			field: "departments",
			headerName: "Departments",
			width: 120,
			disableColumnMenu: true,
			resizable: false,
			renderCell: (params: GridRenderCellParams) => {
				return (
					<Box>
						{params.row.criterias?.departmentIds?.map((departmentId, idx) => {
							return (
								<Chip key={idx} label={departmentId} size="small" />
							)
						})}
					</Box>
				)
			},
		},
		{
			field: "productGroups",
			headerName: "Groups",
			width: 120,
			disableColumnMenu: true,
			resizable: false,
			renderCell: (params: GridRenderCellParams) => {
				return (
					<Box>
						{params.row.criterias?.productGroupIds?.map((productGroupId, idx) => {
							return (
								<Chip key={idx} label={productGroupId} size="small"/>
							)
						})}
					</Box>
				)
			},
		},
		{
			field: "seasons",
			headerName: "Seasons",
			width: 120,
			disableColumnMenu: true,
			resizable: false,
			renderCell: (params: GridRenderCellParams) => {
				return (
					<Box>
						{params.row.criterias?.seasonIds?.map((seasonId, idx) => {
							return (
								<Chip key={idx} label={seasonId} size="small"/>
							)
						})}
					</Box>
				)
			},
		},
	];

	return (
		<DataGridPro
			apiRef={apiRef}
			autoHeight
			density="compact"
			rows={criterias ?? []}
			columns={columns}
			paginationMode="client"
			rowsPerPageOptions={[25, 50, 100]}
			pagination
			onSelectionModelChange={(i) => setRowSelection(i)}
			selectionModel={rowSelection}
			components={{
				Toolbar: GridToolbar,
			}}
			initialState={{
				pagination: {
					pageSize: 25,
				},
			}}
		/>
	);
};

export default CriteriasDataGrid;
